import { render, staticRenderFns } from "./ProcessQueue.vue?vue&type=template&id=b204db3a&scoped=true"
import script from "./ProcessQueue.vue?vue&type=script&lang=js"
export * from "./ProcessQueue.vue?vue&type=script&lang=js"
import style0 from "./ProcessQueue.vue?vue&type=style&index=0&id=b204db3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b204db3a",
  null
  
)

export default component.exports